import React from 'react';

const BankContext = React.createContext();

export default BankContext;
